<style lang="less" scoped>
.mine {
  width: 100%;
  height: 100%;
  background-color: #f0f2f6;
  .header {
    width: 96%;
    height: 400px;
    background: url("https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_297216145797209642021114220964bj2.png")
      no-repeat;
    background-size: 100% 100%;
    padding-top: 45px;
    box-sizing: border-box;
    border-radius: 20px;
    margin: 0 auto;
    .banner {
      width: 193px;
      height: 193px;
      margin: 0 auto;
      // background-color: #fff;
      // border-radius: 50%;
      // overflow: hidden;
      // background: url(data:image/png;base64,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);
      // background-size: 100% 100%;
      position: relative;
      // .imga {
      //   width: 134px;
      //   height: 134px;
      //   position: absolute;
      //   top: 0;
      //   left: 0;
      //   bottom: 0;
      //   right: 0;
      //   margin: auto;
      //   border-radius: 50%;
      //   overflow: hidden;
      // }
    }
    .userName {
      width: 100%;
      //  margin-top: 250px;
      color: #fff;
      text-align: center;
      font-size: 40px;
      img {
        width: 250px;
        height: 250px;
      }
    }
  }
  .selectionbar {
    width: 689px;
    // height: 233px;
    margin: 0 auto;
    margin-top: 13px;
    background-color: #fff;
    border-radius: 20px;
    .item {
      width: 598px;
      height: 115px;
      line-height: 233/2px;
      margin: 0 auto;
      box-sizing: border-box;
      font-size: 28px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        .img1 {
          width: 29px;
          height: 29px;
          margin-right: 12px;
        }
      }
      .img2 {
        width: 29px;
        height: 29px;
        margin-right: 12px;
      }
      img {
        vertical-align: middle;
      }
      .icon {
        display: inline-block;
        width: 9px;
        height: 16px;
        // margin-left: 420px;
      }
    }
  }
}
</style>

<template>
  <div class="mine">
    <div class="header">
      <div class="userName" v-if="openid">
        <!-- <open-data type="userNickName"></open-data> -->
        <img
          src="https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_3852161457974151620211142221516logo.png"
          alt=""
        />
        <br />
        {{ mobile }}
      </div>
      <div v-else>
        <div class="userName" @click="enroll">
          <img
            src="https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_3852161457974151620211142221516logo.png"
            alt=""
          />
          <br />
          点击登录
        </div>
      </div>
    </div>
    <div class="selectionbar">
      <div
        class="item"
        style="border-bottom: 1px solid #e6e9ed"
        @click="order(1)"
        v-if="openid"
      >
        <div class="left">
          <img
            class="img1"
            src="/static/images/icon_order.png"
            alt
          />我的信息&nbsp;
          {{ userName }}
        </div>
        <img class="icon" src="/static/images/fanhui.png" alt />
      </div>
      <div
        class="item"
        style="border-bottom: 1px solid #e6e9ed"
        @click="order(2)"
        v-if="openid"
      >
        <div class="left">
          <img class="img1" src="/static/images/shouji.png" alt />退出登录
        </div>
        <img class="icon" src="/static/images/fanhui.png" alt />
      </div>
      <!-- <div class="item" style="border-bottom:1px solid #E6E9ED;" @click="entrance('g')">
        <div class="left">
          <img class="img1" src="/static/images/icon_order.png" alt />个体户列表
        </div>
        <img class="icon" src="/static/images/fanhui.png" alt />
      </div> -->
      <!-- <div class="item" style="border-bottom:1px solid #E6E9ED;" @click="entrance('z')">
        <div class="left">
          <img class="img1" src="/static/images/icon_order.png" alt />转账交易
        </div>
        <img class="icon" src="/static/images/fanhui.png" alt />
      </div>
      <div class="item" style="border-bottom:1px solid #E6E9ED;" @click="entrance('f')">
        <div class="left">
          <img class="img1" src="/static/images/icon_order.png" alt />发票列表
        </div>
        <img class="icon" src="/static/images/fanhui.png" alt />
      </div> -->
      <!-- 测试 -->
      <!-- <div class="item" style="border-bottom:1px solid #E6E9ED;" @click="order(2)" v-if="isAuditor">
        <img class="img1" src="/static/images/icon_order.png" alt />订单审核
        <img class="icon" src="/static/images/fanhui.png" alt />
      </div> -->
      <!-- <div>
        <picker @change="phoneCall" :value="index" :range="telphones">
                <view class="picker">
                    <img class="img2" src="/static/images/kefu.png" alt="">客服电话
                    <img class="icon" src="/static/images/fanhui.png" alt="">
                </view>
        </picker>
      </div> -->
    </div>
    <div id="modal" v-if="tankuang">
      <div class="fangkuai">
        <div class="weideng">您还未登录</div>
        <div class="jinxin">请先登录在进行操作</div>
        <div class="tupian">
          <img
            src="/static/images/huojian.png"
            alt
            style="width: 100px; height: 100px"
          />
        </div>
        <div class="juzhong">
          <div>
            <button class="baoguo" @click="tankuang = false">暂不登录</button>
          </div>
          <div>&nbsp;&nbsp;</div>
          <div>
            <button
              class="button1"
              open-type="getUserInfo"
              lang="zh_CN"
              @getuserinfo="onGotUserInfo"
            >
              立即登录
            </button>
          </div>
        </div>
      </div>
    </div>
    <tabbar></tabbar>
  </div>
</template>

<script>
import http from "../../api/index.js";
import config from "../../utils/config.js";
import tabbar from "@/components/tabbar";

export default {
  data() {
    return {
      telphone: null,
      isAuditor: false,
      telphones: [],
      openid: null,
      tankuang: false,
      userName: "",
      mobile: "",
    };
  },
  created() {
    this.openid = sessionStorage.getItem("esignappsid");
    // console.log(this.openid)
    if (sessionStorage.getItem("esignappsid")) {
      this.saasorderbusinessmenPagePost();
    }
  },
  onShow: function () {
    this.openid = sessionStorage.getItem("esignappsid");
  },
  methods: {
    saasorderbusinessmenPagePost() {
      http.post(config.signInfo).then((e) => {
        // console.log(e,'个体户详情')
        if (e.code == 0) {
          this.userName = e.data.authStatusName;
          if (e.data.userName) {
            this.mobile = e.data.userName;
          } else {
            this.mobile = e.data.mobile;
          }
        }
      });
    },
    phoneCall(val) {
      let index = val.target.value;
      wx.makePhoneCall({
        phoneNumber: this.telphones[index],
      });
    },
    order(i) {
      if (i == 1) {
        if (sessionStorage.getItem("esignappsid")) {
          const url = "/individualDetails";
          this.$router.push({ path: url });
        } else {
          this.$toast.warn("请先登录");
        }
      } else {
        sessionStorage.removeItem("esignappsid");
        this.$toast.success("退出成功");
        location.reload();
      }
    },
    entrance(val) {
      if (sessionStorage.getItem("esignappsid")) {
        let url = "";
        if (val == "g") {
          url = "/individualList";
        } else if (val == "f") {
          url = "/invoiceList";
        } else if (val == "z") {
          url = "/transferList";
        }
        this.$router.push({ path: url });
      } else {
        this.$toast.warn("请先登录");
      }
    },
    enroll() {
      // this.tankuang = true;
      let url = "/login";
      this.$router.push({ path: url });
    },
    onGotUserInfo(e) {
      var that = this;
      wx.login({
        success(res) {
          console.log(e);
          console.log(res);
          if (res.code) {
            http
              .post(config.login, {
                iv: e.mp.detail.iv,
                encryptedData: e.mp.detail.encryptedData,
                code: res.code,
                merchant_id: "11247613260000707",
                avatarUrl: e.mp.detail.userInfo.avatarUrl,
                nickName: e.mp.detail.userInfo.nickName,
              })
              .then((e) => {
                if (e.code == 1) {
                  sessionStorage.setItem("openId", e.data.openid);

                  this.$toast.success("登录成功");
                  that.tankuang = false;
                  const pages = getCurrentPages();
                  const perpage = pages[pages.length - 1];
                  perpage.mounted();
                }
              });
          } else {
            console.log("登录失败！" + res.errMsg);
          }
        },
      });
    },
  },
  components: {
    tabbar: tabbar,
  },
};
</script>
<style scoped>
#modal {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 90;
  background-color: rgba(0, 0, 0, 0.6);
}
#modal .fangkuai {
  width: 550px;
  height: 600px;
  border: 2px solid #fff;
  margin: 0 auto;
  margin-top: 200px;
  background: #fff;
  border-radius: 25px;
}
#modal .juzhong {
  display: flex;
  justify-content: center;
  margin-top: 80px;
}
#modal .tupian {
  margin: 0 auto;
  width: 100px;
  margin-top: 60px;
}
#modal .weideng {
  text-align: center;
  margin-top: 70px;
  font-weight: 600;
  font-size: 38px;
}
#modal .jinxin {
  text-align: center;
  margin-top: 30px;
  font-size: 30px;
  color: #666;
}
#modal .baoguo {
  width: 230px;
  height: 80px;
  margin: 0 auto;

  line-height: 80px;
  color: #6badff;
  text-align: center;
  background: #fff;
  border-radius: 40px;
  border: 1px solid #6badff;
  font-size: 33px;
}
#modal .button1 {
  width: 230px;
  height: 80px;
  margin: 0 auto;

  line-height: 80px;
  color: #fff;
  text-align: center;
  background: #6badff;
  border-radius: 40px;
  border: 1px solid #6badff;
  font-size: 33px;
}
</style>





// WEBPACK FOOTER //
// src/pages/mine/index.vue